module.exports = __webpack_public_path__ + "img/s2s-new-logo.3c957f52.png";